import { formatDistanceToNow } from 'date-fns';
import { fr } from 'date-fns/locale';

export function formatRelativeDate(date) {
  if (!date) return '';
  return formatDistanceToNow(new Date(date), { addSuffix: true, locale: fr });
}

// Expiration dates only ever carry month/year meaning (packaging never prints
// a day), so every batch/lot expiration is shown the same way across the app —
// as "MM/YYYY" — regardless of the day stored internally.
export function formatExpirationDate(date) {
  if (!date) return '';
  return new Date(date).toLocaleDateString('fr-FR', {
    month: '2-digit',
    year: 'numeric',
  });
}

export function formatFullDate(date) {
  if (!date) return '';

  return new Date(date).toLocaleString('fr-FR', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  });
}
// Listing date: "30 oct. · 16:19" (year added when it isn't the current one) — the exact
// moment, with formatRelativeDate() shown underneath it by DateCell
export function formatListingDate(date) {
  if (!date) return '';
  const d = new Date(date);
  const sameYear = d.getFullYear() === new Date().getFullYear();
  const day = d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', ...(sameYear ? {} : { year: 'numeric' }) });
  const time = d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  return `${day} · ${time}`;
}

// true when the date falls on today (local date) — listings tint today's rows with it
export function isToday(date) {
  return !!date && new Date(date).toDateString() === new Date().toDateString();
}
